import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
var DEFAULT_CONFIGURATION = {};
export var ConfigurationContext = /*#__PURE__*/ React.createContext(DEFAULT_CONFIGURATION);
export var withConfigurationConsumer = function(Component) {
    return function withConfigurationConsumer(props) {
        var configuration = useContext(ConfigurationContext);
        var composedProps = _object_spread_props(_object_spread({}, props), {
            configuration: configuration
        });
        return /*#__PURE__*/ _jsx(Component, _object_spread({}, composedProps));
    };
};
